import request from '@/utils/request'
// 获取商品一级分类
export function productCategoryOne(params) {
    return request({
        url: '/product/productCategoryOne',
        method: 'get',
        params: params
    })
}
// 获取商品二三级分类(根据一级分类)
export function productCategoryTwoThree(params) {
    return request({
        url: '/product/productCategoryTwoThree',
        method: 'get',
        params: params
    })
}